import { createContext } from 'react'

interface MarkAuftraegeAsDoneContextType {
  isDone: (id: string) => boolean
  setMarkedAsDone: (id: string, state: boolean) => void
  befehlFrontendId: string | undefined
  isBefehlsnachrichtQuittiert: boolean | undefined
  setIsBefehlsnachrichtQuittiert: (isQuittiert: boolean) => void
}

const MarkAuftraegeAsDoneContext = createContext<
  MarkAuftraegeAsDoneContextType | undefined
>(undefined)

export default MarkAuftraegeAsDoneContext
